export const DASHBOARD_STYLED_CONSTS = {
    NAVBAR_HEIGHT: 48,
    HEADER_HEIGHT: 55, // 1px more than on Figma (because of border-bottom 1 px)
    SIDEBAR_WIDTH: 224,
    CONTENT_PADDING_HORIZONTAL: 16,
    CONTENT_PADDING_TOP: 72,
    CONTENT_PADDING_BOTTOM: 20,
    CONTENT_PADDING_HORIZONTAL_LAPTOP: 32,
};
